/* Mr. Lemonade mega menu behaviour */
(function () {
  var root = document.querySelector('[data-mm]');
  if (!root || root.getAttribute('data-mm-ready')) return;
  root.setAttribute('data-mm-ready', '1');

  var bar = root.querySelector('.mm-bar');
  var shopBtn = root.querySelector('[data-mm-shop]');
  var panel = root.querySelector('[data-mm-panel]');
  var burger = root.querySelector('[data-mm-burger]');
  var closeBtn = root.querySelector('[data-mm-close]');
  var desktop = window.matchMedia('(min-width: 1100px)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var openTimer, closeTimer, lastY = window.pageYOffset;
  var html = document.documentElement;

  function syncTop() {
    var b = bar.getBoundingClientRect().bottom;
    root.style.setProperty('--mm-panel-top', Math.max(0, Math.round(b)) + 'px');
  }
  function setHeaderVar() {
    var h = Math.ceil(bar.getBoundingClientRect().height);
    html.style.setProperty('--theme-header-height', h + 'px');
  }
  function openPanel() {
    clearTimeout(closeTimer);
    if (!desktop.matches || root.classList.contains('is-open')) return;
    syncTop();
    lastY = window.pageYOffset;
    root.classList.add('is-open');
    shopBtn.setAttribute('aria-expanded', 'true');
  }
  function closePanel() {
    clearTimeout(openTimer);
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    shopBtn.setAttribute('aria-expanded', 'false');
  }
  function openDrawer() {
    root.classList.add('is-drawer-open');
    burger.setAttribute('aria-expanded', 'true');
    html.classList.add('mm-lock');
    setTimeout(function () { closeBtn.focus(); }, 60);
  }
  function closeDrawer(returnFocus) {
    if (!root.classList.contains('is-drawer-open')) return;
    root.classList.remove('is-drawer-open');
    burger.setAttribute('aria-expanded', 'false');
    html.classList.remove('mm-lock');
    if (returnFocus) burger.focus();
  }
  function schedOpen() {
    if (!canHover.matches) return;
    clearTimeout(closeTimer);
    openTimer = setTimeout(openPanel, 90);
  }
  function schedClose() {
    if (!canHover.matches) return;
    clearTimeout(openTimer);
    closeTimer = setTimeout(closePanel, 180);
  }

  shopBtn.addEventListener('mouseenter', schedOpen);
  shopBtn.addEventListener('mouseleave', schedClose);
  panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
  panel.addEventListener('mouseleave', schedClose);
  shopBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (root.classList.contains('is-open')) {
      if (e.detail === 0 || !canHover.matches) closePanel();
    } else {
      openPanel();
    }
  });
  burger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', function () { closeDrawer(true); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (root.classList.contains('is-open')) { closePanel(); shopBtn.focus(); }
    closeDrawer(true);
  });
  /* Click anywhere outside the header closes the panel; page stays visible and usable underneath. */
  document.addEventListener('click', function (e) {
    if (root.classList.contains('is-open') && !root.contains(e.target)) closePanel();
  });
  /* The panel is pinned under the header, so close it if the page scrolls. */
  window.addEventListener('scroll', function () {
    if (root.classList.contains('is-open') && Math.abs(window.pageYOffset - lastY) > 6) closePanel();
  }, { passive: true });

  function onViewportChange() {
    setHeaderVar();
    if (desktop.matches) {
      closeDrawer(false);
      if (root.classList.contains('is-open')) syncTop();
    } else {
      closePanel();
    }
  }
  window.addEventListener('resize', onViewportChange);
  if (desktop.addEventListener) desktop.addEventListener('change', onViewportChange);

  /* The old header's helpers no longer apply: keep the theme's header-height variable correct. */
  if (window.theme) {
    theme.inlineNavigationCheck = function () {};
    theme.setInitialHeaderHeightProperty = setHeaderVar;
  }
  setHeaderVar();
})();